// import postCard from '';
// import { useMutation } from '@tanstack/react-query';
// import linkedInService from 'features/social-media/services/linkedinApi';
// import twitterService from 'features/social-media/services/twitterApi';
import { Button } from 'components/ui/button';
import { NavLink } from 'react-router-dom';

const PostCard = ({ value, image }: { value: string; image: string }) => {
  return (
    <div className="w-full lg:w-[330px] flex flex-col max-w-[330px] bg-background text-text-primary rounded-lg shadow-lg p-7">
      <div className="text-lg font-semibold mb-4 opacity-[62.75%]">
        {value.includes('linkedIn') ? 'LinkedIn' : 'X'}
      </div>

      <img
        src={image}
        alt="no img"
        className="w-full lg:w-[280px] h-auto lg:h-[270px] mb-9 rounded-lg object-cover"
      />

      <Button variant={'customPrimary'} asChild className="w-full">
        <NavLink to={`/social-media/post${value}`}>Make Post</NavLink>
      </Button>

      {/* <div className="w-full mt-3">
        {value.includes('linkedIn') && (
          <Button
            disabled={linkedIn.isPending}
            onClick={() => {
              linkedIn.mutate();
            }}
            variant={'customSecondary'}
            className="w-full"
          >
            Connect LinkedIn
          </Button>
        )}

        {value.includes('x') && (
          <Button
            onClick={() => {
              x.mutate();
            }}
            disabled={x.isPending}
            variant={'customSecondary'}
            className="w-full"
          >
            Connect X
          </Button>
        )}
      </div> */}
    </div>
  );
};

export default PostCard;
